import { useRef } from "react";
import HomeResources from "@/components/marketing/HomeResources";
// Cinematic homepage PREVIEW — isolated, noindex. Approved hero from the supplied
// package, then cinematic sections carrying every existing homepage section's content.
import { SEO } from "@/lib/seo";
import { CinematicExact } from "@/components/marketing/CinematicExact";
import { ConnectedPlatform, FeatureShowcases, ProductExperience, WhyFieldlink, FinalCinematicCTA } from "@/components/marketing/CinematicSections";
import { useReveal } from "@/components/marketing/CinematicParts";
import { CustomerProof, Pricing, FAQ } from "@/components/marketing/WebsiteSections";
import { MarketingFooter } from "@/components/marketing/MarketingSections2";
import { PLANS } from "@/data/marketing";

const JSON_LD = {
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  name: "Fieldlink NZ",
  applicationCategory: "BusinessApplication",
  operatingSystem: "Web, Android, iOS",
  description: "Civil construction management software for NZ contractors — takeoffs, quoting, jobs, crews, plant, safety, job costing and invoicing in one platform.",
  offers: PLANS.map((p) => ({ "@type": "Offer", name: `Fieldlink ${p.name}`, price: p.price, priceCurrency: "NZD", url: "https://www.fieldlink.co.nz/register" })),
};

export default function LandingCinematic() {
  const main = useRef(null);
  useReveal(main);
  return (
    <div className="web-site fx-page" data-testid="landing-page">
      <SEO
        title="Civil Construction Software NZ | Fieldlink"
        description="From takeoff and quoting to crews, plant, safety, job costing and invoicing — Fieldlink connects the office and field without the paperwork. Built in NZ for civil contractors. 7-day free trial."
        path="/"
        jsonLd={JSON_LD}
      />
      <a className="web-skip" href="#main-content">Skip to content</a>
      <main id="main-content" ref={main}>
        <CinematicExact />
        <ConnectedPlatform />
        <FeatureShowcases />
        <ProductExperience />
        <WhyFieldlink />
        <HomeResources />
        <CustomerProof />
        <Pricing />
        <FAQ />
        <FinalCinematicCTA />
      </main>
      <MarketingFooter />
    </div>
  );
}
